import posthog from 'posthog-js';

/**
 * Capture a custom event in PostHog
 * @param eventName The name of the event to capture
 * @param properties Optional properties to include with the event
 */
export const captureEvent = (eventName: string, properties?: Record<string, any>) => {
  if (typeof window !== 'undefined' && posthog.__loaded) {
    posthog.capture(eventName, properties);
  }
};

/**
 * Identify a user in PostHog
 * @param userId The unique identifier for the user
 * @param properties Optional user properties to set
 */
export const identifyUser = (userId: string, properties?: Record<string, any>) => {
  if (typeof window !== 'undefined' && posthog.__loaded) {
    posthog.identify(userId, properties);
  }
};

/**
 * Reset the current user in PostHog (for logout)
 */
export const resetUser = () => {
  if (typeof window !== 'undefined' && posthog.__loaded) {
    posthog.reset();
  }
};
